import { render, staticRenderFns } from "./ChooseCharacter.vue?vue&type=template&id=2c2054d4&scoped=true&"
import script from "./ChooseCharacter.vue?vue&type=script&lang=js&"
export * from "./ChooseCharacter.vue?vue&type=script&lang=js&"
import style0 from "./ChooseCharacter.vue?vue&type=style&index=0&id=2c2054d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2054d4",
  null
  
)

export default component.exports